// components/Auth/Login.js
import React, { useState } from 'react';
import { login } from '../../utils/auth';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState(''); 
  const [error, setError] = useState('');
  const [showNewPasswordField, setShowNewPasswordField] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const tokens = await login(
        username,
        password,
        showNewPasswordField ? newPassword : null
      );
      onLogin(tokens);
    } catch (err) {
      console.error('Error during login:', err);
      if (err.message.includes('NEW_PASSWORD_REQUIRED')) {
        setShowNewPasswordField(true);
        setError('New password required. Please enter a new password.');
      } else {
        setError(err.message || 'Failed to log in');
      }
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-r from-gray-700 via-gray-800 to-gray-900">
      <form
        onSubmit={handleSubmit}
        className="bg-gray-800 p-8 rounded-lg shadow-lg space-y-6 max-w-sm w-full"
      >
        <div className="flex items-center justify-center space-x-3">
          <img
            src="/unity_living_logo_white.webp"
            alt="Unity Living Logo"
            className="h-20 w-20 rounded-lg"
          />
          <h1 className="text-3xl font-semibold text-gray-100">
            Admin Login
          </h1>
        </div>
        {error && (
          <p className="text-red-400 text-sm text-center">{error}</p>
        )}
        <input
          type="text"
          placeholder="Username"
          className="w-full px-4 py-2 border border-gray-600 rounded bg-gray-700 text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder={showNewPasswordField ? 'Current Password' : 'Password'}
          className="w-full px-4 py-2 border border-gray-600 rounded bg-gray-700 text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {showNewPasswordField && (
          <input
            type="password"
            placeholder="New Password"
            className="w-full px-4 py-2 border border-gray-600 rounded bg-gray-700 text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        )}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded shadow hover:bg-blue-700 transition duration-300"
        >
          {showNewPasswordField ? 'Submit New Password' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Login;
